import React from 'react'
import logo from '../assets/logo.png'
import twitter from '../assets/twitter.png'
import youtube from '../assets/youtube.png'

const Footer = () => {
  return (
    <div>
        <footer className='footer'>
                <div className='footer-text h-full flex justify-around items-center' style={{ height: '100%'}}>
                <p className='footer-title' style={{}}>Copyright ©️ <span> 2023</span></p>

                    <div className="max-w-[100px] sm:max-w-[120px] mt-[82.5px] sm:mt-0 relative pt-[10px]" style={{height: '100px'}}>
                       <span className='w-[112.5px] absolute text-xs md:text-sm top-[0] flex justify-center'>Made with ❤️ by</span><img src={logo} alt='' style={{width:'100%', height:'100%', objectFit:'contain'}}/>
                    </div>
                    <div className='socials flex items-center w-[70px] sm:w-[100px] h-[70px]'>
                      <a href='https://twitter.com/BurgerZombies' target='_blank' rel='noreferrer noopener' className='flex justify-center'><img title='Twitter' src={twitter} className='w-[80%] px-[10%]'  alt='' cursor-pointer/></a>
                      <a href='https://www.youtube.com/@BurgerZombies' target='_blank' rel='noreferrer noopener' className='flex content-center'><img title='YouTube' src={youtube} className='w-[80%] px-[10%] cursor-pointer' alt=''/></a>
                    </div>
                </div>
        </footer>
    </div>
  )
}

export default Footer
